import React from 'react';
import { Card, Col, Row, Tag } from 'antd';
import moment from 'moment';

import { EEZEE_URL, SUPPLIER_URL } from '../../../index.js';

const ItemCard = ({product}) => {
    
    const { _id, active, categories, dateCreated, title, uniqTitle, sku, images, baseCurrency } = product;

    const uploadedDate = moment(dateCreated).format('LL');
    return(
        <Card 
            className="item-card" >

            <Row type="flex" align="middle" className="item-card-image-container">
            
                { images.length > 0 && (
                    <img
                        alt="Item pic" 
                        className="item-card-image" 
                        src={images[0].url} 
                    />
                )}
                
            </Row>
            
            <Row className="item-card-details-container">
                <Row className="item-card-body" >

                    <Row type="flex" justify="space-between" className="item-card-product-category">
                        
                        <Col span={15} >
                            {categories.main}
                        </Col>

                        <Col span={4} 
                            className={(active)? 'product-active-tag-active' : 'product-active-tag-inactive'} 
                            style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gridColumnGap: 2}}
                            >

                            <Tag color={(active)? 'green' : 'red' } >
                                {(active)? 'Active' : 'Inactive'}
                            </Tag>
                            <Tag>
                                {baseCurrency}
                            </Tag>

                        </Col>

                        <Col span={2}>

                        </Col>

                    </Row>

                    <Row className="item-card-product-title">
                        {title} 
                    </Row>

                    

                </Row>

                <Row type="flex" justify="end" className="item-card-product-uploaded-container">
                    <Col >
                        {uploadedDate}
                    </Col>
                </Row>

                <Row type="flex" className="item-card-footer-action-container" gutter={5}>
                    <Col span={11}>
                        <div className="item-card-footer-button">
                            <a className="item-card-footer-action"
                                target={`view_product_${uniqTitle}_${sku}`}
                                href={`${EEZEE_URL}/product/${uniqTitle}-${sku}`}>
                                View
                            </a>
                        </div>

                    </Col>
                    <Col span={2} className="item-card-footer-divider">
                        <div style={{margin: 'auto', width:'50%', textAlign: 'center'}}>
                            |
                        </div>
                    </Col>
                    <Col span={11}>
                        <div className="item-card-footer-button">
                            <a className="item-card-footer-action" target={`edit_product_${uniqTitle}_${sku}`}
                                href={`${SUPPLIER_URL}/products/${_id}`}>
                                Edit
                            </a>
                        </div>
                    </Col>

                        

                </Row>
                    
            </Row>
        </Card>
    )
}

export default ItemCard;


// WEBPACK FOOTER //
// ./src/components/supplier-profile/profile-body/item-card.js